// extracted by mini-css-extract-plugin
export default {"blitzle":"pokemonGif_blitzle__jB7R-","cinderace":"pokemonGif_cinderace__qdHTK"};